module.exports = __webpack_public_path__ + "627b8f7195b23aa716c48e693407d419.png";